import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export default function OutlinedCard(props: any) {
  return (
    <Card variant="outlined" sx={{
      backgroundColor: props.backgroundColor,
      maxWidth: props.maxWidth,
      height: props.height,
      borderRadius: props.borderRadius,
      paddingLeft:props.paddingLeft,
      paddingRight:props.paddingRight,
      paddingTop:props.paddingTop,
      textAlignVertical:props.textAlignVertical
    }} >
      <CardContent className='number-card'>
        <Box width='100%' boxSizing={'border-box'} display={'flex'} flexDirection='row' alignItems={'center'} justifyContent='space-between'>
          <Typography sx={{ fontSize: 14 }} color="white">
            {props.title}
            {props.icon}
          </Typography>
          <Typography fontSize={'30px'} color="white">
            {props.value}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

